import { connect } from 'react-redux';

import AddedElections from './component';

import {
  adminApproveElection,
  adminUnapproveElection,
  getAllApprovedElections,
  getAllUnapprovedElections,
} from '../../../../state/actions';

const mapStateToProps = (state) => {
  const {
    elections: {
      approved_elections: approvedElections = [],
      unapproved_elections: unapprovedElections = [],
    },
  } = state;

  return {
    approvedElections,
    unapprovedElections,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    adminApproveElection: (electionId) => {
      dispatch(adminApproveElection(electionId));
    },
    adminUnapproveElection: (electionId) => {
      dispatch(adminUnapproveElection(electionId));
    },
    getAllApprovedElections: () => {
      dispatch(getAllApprovedElections());
    },
    getAllUnapprovedElections: () => {
      dispatch(getAllUnapprovedElections());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddedElections);
